import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';
import { Button } from './button';
import { Input } from './input';
import { Field, Label } from './fieldset';

// RFC: 3-4 letters + 6 digits + 3 alphanumeric (e.g. XAXX010101000 or ABC010101AB1)
const RFC_REGEX = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;

const validateRfc = (value) => {
  if (!value) return null; // optional field
  if (!RFC_REGEX.test(value)) {
    return 'RFC inválido. Formato: 3-4 letras + 6 dígitos + 3 alfanuméricos';
  }
  return null;
};

const BeneficiarioDialog = ({ isOpen, onClose, onSubmit, beneficiario, loading }) => {
  const [nombre, setNombre] = useState('');
  const [rfc, setRfc] = useState('');
  const [rfcError, setRfcError] = useState(null);

  const isEdit = Boolean(beneficiario);

  useEffect(() => {
    if (beneficiario) {
      setNombre(beneficiario.nombre || '');
      setRfc(beneficiario.rfc || '');
    } else {
      setNombre('');
      setRfc('');
    }
    setRfcError(null);
  }, [beneficiario, isOpen]);

  const handleRfcChange = (e) => {
    const value = e.target.value.toUpperCase();
    setRfc(value);
    if (rfcError) setRfcError(validateRfc(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;

    const error = validateRfc(rfc);
    if (error) {
      setRfcError(error);
      return;
    }

    await onSubmit({
      nombre: nombre.trim(),
      rfc: rfc.trim(),
      ...(beneficiario ? { id: beneficiario.id } : {}),
    });

    setNombre('');
    setRfc('');
    setRfcError(null);
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{isEdit ? 'Editar Beneficiario' : 'Nuevo Beneficiario'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogBody>
          <div className="space-y-4">
            <Field>
              <Label>Nombre / Razón Social</Label>
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre del beneficiario"
                required
                autoFocus
              />
            </Field>
            <Field>
              <Label>RFC</Label>
              <Input
                value={rfc}
                onChange={handleRfcChange}
                placeholder="Ej. XAXX010101000"
                maxLength={13}
                className={rfcError ? 'border-red-500' : ''}
              />
              {rfcError && (
                <p className="mt-1 text-xs text-red-600">{rfcError}</p>
              )}
            </Field>
          </div>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={onClose} type="button">
            Cancelar
          </Button>
          <Button type="submit" disabled={!nombre.trim() || loading}>
            {loading ? 'Guardando...' : isEdit ? 'Guardar Cambios' : 'Agregar Beneficiario'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default BeneficiarioDialog;
